import axios, { AxiosError }                                         from 'axios';
import { FormikHelpers }                                             from 'formik';
import qs                                                            from 'qs';
import React, { FC }                                                 from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled                                                        from 'styled-components';
import { LogoBlue }                                                  from '../../shared/components/Logo';
import { EAuthRoutes }                                               from '../../shared/constants/constants';
import { queryParams }                                               from '../../shared/functions';
import { IErrorResponse }                                            from '../shared/interfaces';
import { PageHeader, PageHeaderText, SignInUpPage, SignUpContainer } from '../shared/styles';
import { IResetPasswordForm, ResetPasswordForm }                     from './ResetPasswordForm';
import { Notistack } from "../../shared/components/Notistack/Notistack";
import { FormFieldWrapper } from "../CreateFamily/CreateFamily";
import { AuthResponseKeys } from "../../shared/interfaces/auth";

const Header = styled(PageHeader)`&& {
  ${ ({ theme: { breakpoints } }) => breakpoints.up('md') } {
    padding: 0 140px;
  }
}`;

export const ResetPassword: FC = () => {
  const { email, code } = queryParams();
  const history = useNavigate();

  const handleSubmit = ({ password, confirmPassword }: IResetPasswordForm, formikActions: FormikHelpers<IResetPasswordForm>) => {
    const requestBody = {
      email: email.replace(/ /g, '+'),
      code,
      password,
      confirmPassword,
    };

    formikActions.setSubmitting(true);

    axios.put('/api/v1/verifications/password', requestBody)
      .then(() => {
        Notistack.enqueueSnackbar('Password have been update successfully!.', 'success');
        history({
          pathname : EAuthRoutes.SignIn,
          search   : qs.stringify({ email: email.replace(/ /g, '+') }),
        });
      })
      .catch((err: AxiosError<IErrorResponse>) => {
        const errorDetails = err?.response?.data?.ErrorDetails;
        if (errorDetails) {
          let { Key, Message } = errorDetails;
          if(Key === AuthResponseKeys.INVALIDTOKEN){
            Message = 'This password reset link has already been used. Please request a new one.';
          }
          formikActions.setErrors({
            [Key]: Message,
          });
          formikActions.setSubmitting(false);
          Notistack.enqueueSnackbar(Message, 'error');
        }
      });
  };

  return (
    <SignInUpPage>
      <SignUpContainer maxWidth="md">
        <Header mb="35px">
          <LogoBlue margin="0 0 30px" />

          <PageHeaderText
            centered
            maxWidth="530px"
            padding="0 30px"
          >
            Choose and Confirm Your New Password
          </PageHeaderText>
        </Header>

        <ResetPasswordForm handleSubmit={handleSubmit} />
        <FormFieldWrapper centered textCentered>
            Return to <Link to={EAuthRoutes.SignIn}>Sign in</Link>
        </FormFieldWrapper>
      </SignUpContainer>
    </SignInUpPage>
  );
};
